<script>
// inspiré de https://vuejs.org/v2/guide/render-function.html#Basics
// Ce composant ne devrait être utilisé qu'à travers le composant titre
export default {
  name: 'Heading',
  props: {
    contentType: {
      type: String,
      required: true,
    },
  },
  computed: {
    headingLevel() {
      return this.getTypeLevel();
    },
  },
  methods: {
    getTypeLevel() {
      if (this.contentType) {
        if (this.contentType === 'tresGrandTitre' || this.contentType === 'grandTitre') {
          return 1;
        }
        if (this.contentType === 'titre') {
          return 2;
        }
        if (this.contentType === 'sousTitre') {
          return 3;
        }
        if (this.contentType === 'titre-h4') {
          return 4;
        }
        if (this.contentType === 'titre-h5') {
          return 5;
        }
        if (this.contentType === 'titre-h6') {
          return 6;
        }
        return 6;
      }
      return null;
    },
  },
  render(createElement) {
    return createElement(
      `h${this.headingLevel}`, // tag name
      this.$slots.default // array of children
    );
  },
};
</script>
